<template>
    <div>
        <div class="mb-2 flex flex-row gap-2">
            <FileUploadButton
                title="upload_asset_investment_report"
                accept=".csv, .xlsx, .xls"
                mode="private"
                :file-name="assetInvestmentReportFileName"
                @submit="onAssetInvestmentReportUpload"
                @delete="onAssetInvestmentReportDelete"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import FileUploadButton from '@partials/actions/FileUploadButton.vue'
import { UploadFileResponse } from '@src/utils/api/s3'
import { Ref, ref, toRefs } from 'vue'

const props = defineProps<{
    modelValue: Ref<UploadFileResponse | null>
}>()

const { modelValue } = toRefs(props)
const emit = defineEmits(['update:modelValue'])

const assetInvestmentReportFileName = ref<string | null>(null)

function onAssetInvestmentReportUpload(
    response: UploadFileResponse,
    fileName: string
) {
    assetInvestmentReportFileName.value = fileName
    modelValue.value = response
    emit('update:modelValue', response)
}

function onAssetInvestmentReportDelete() {
    modelValue.value = null
    assetInvestmentReportFileName.value = null
}
</script>

<style scoped></style>
